import { render } from "./StudentPortal.vue?vue&type=template&id=cde9c480"
import script from "./StudentPortal.vue?vue&type=script&lang=js"
export * from "./StudentPortal.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__